import React from 'react';
import PropTypes from 'prop-types';

import { MessageResult } from 'src/Components';
import { i18, Payment, translationGroups } from 'src/Utilities';
import { CloseCircleOutlined } from '@ant-design/icons';

export const PaymentUnsuccess = ({ resetPayment, editPayment, close, error, paymentType }) => {
  const buttons = [];

  if (resetPayment) {
    buttons.push({
      title: paymentType === Payment.NEW ? i18.Buttons.PaymentUnsuccessfullyEdit : i18.Buttons.NewPaymentInstruction,
      func: Payment.NEW ? editPayment : resetPayment,
      props: {
        type: paymentType === Payment.NEW ? 'primary' : undefined,
        icon: null,
      },
    });

    buttons.push({
      title: i18.Buttons.PaymentUnsuccessfullyCancel,
      func: resetPayment,
      props: {
        icon: null,
      },
    });
  }

  if (close) {
    buttons.push({
      title: i18.Buttons.Close,
      func: close,
      props: {
        type: 'primary',
        icon: <CloseCircleOutlined aria-hidden="true" />,
      },
    });
  }

  return (
    <MessageResult
      status="error"
      title={i18.MessageTitles.PaymentUnsuccess}
      subTitle={error ? translationGroups.ErrorCode + error : i18.Messages.PaymentUnsuccess}
      buttons={buttons}
    />
  );
};

PaymentUnsuccess.propTypes = {
  close: PropTypes.func,
  paymentType: PropTypes.string,
  resetPayment: PropTypes.func.isRequired,
  error: PropTypes.string,
};

